<template>
  <main class="partners-page">
    <div class="ui-container">
      <header class="partners-page__header">
        <h1 class="partners-page__title h h--2">
          Партнёры
        </h1>

        <p class="partners-page__desc p p--2">
          Хотите присоединиться к&nbsp;Академике?
          <a href="/partnership/#feedback-form">Оставьте заявку</a>
          и&nbsp;мы&nbsp;свяжемся с&nbsp;вами в&nbsp;ближайшее время
        </p>
      </header>

      <ul v-if="sortedCompanies" class="partners-page__list">
        <li
          v-for="company in sortedCompanies"
          :key="company.id"
          class="partners-page__item"
        >
          <UiPartnerCard
            :card="company"
            class="partners-page__card"
          />
        </li>
      </ul>
    </div>
  </main>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { getUiPictureData } from '@academica-box/helpers/getUiPictureData'
  import UiPartnerCard from '@academica-box/components/Cards/UiPartnerCard/UiPartnerCard.vue'
  import { usePartnersStore } from '@/store/partners'
  import type { CompanyType } from '@/api/partners'

  const partnersStore = usePartnersStore()
  const { companies } = storeToRefs(partnersStore)

  const sortedCompanies = computed(() => {
    const companiesArray = companies?.value ? Object.values(companies.value) : []
    const arr: CompanyType[] = []
    const collator = new Intl.Collator('ru')

    companiesArray.map(companies => companies).map(array => array.map(company => arr.push(company)))

    return arr.map((item) => {
      return {
        id: item.id,
        images: getUiPictureData({ sm: [item.logo || ''] }),
        title: item.abbreviation || '',
        description: item.name || '',
        tags: item.directions?.map(direction => ({
          text: direction.title || '',
          images: getUiPictureData({ sm: [direction.image || ''] })
        })) || [],
        link: `/vendor/${item.slug}/`
      }
    }).sort((a, b) => collator.compare(a.title, b.title))
  })

  await useAsyncData(
    'getCompanies',
    () => partnersStore.getCompanies()
  )

  useHead({
    title: 'Партнёры | Академика',
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/combinations/media-hover-reset' as *;

  .partners-page {
    padding-bottom: 56px;

    @include media(lg) {
      padding-bottom: 96px;
    }
  }

  .partners-page__header {
    margin-bottom: 28px;

    @include media(lg) {
      display: grid;
      grid-gap: 32px;
      grid-template-columns: 1fr 448px;
      margin-bottom: 40px;
    }

    @include media(xl) {
      grid-template-columns: 1fr 504px;
    }

    @include media(xxl) {
      grid-template-columns: 1fr 670px;
    }
  }

  .partners-page__title {
    margin-bottom: 16px;

    @include media(md-max) {
      margin-top: 4px;
    }

    @include media(lg) {
      margin-bottom: 0;
    }
  }

  .partners-page__desc {
    margin-bottom: 0;
    color: var(--text-secondary-color);

    a {
      color: inherit;
      text-decoration: underline;
      text-decoration-skip-ink: none;

      @include hover {
        text-decoration: none;
      }
    }
  }

  .partners-page__list {
    @include ulres;

    @include media(md) {
      display: grid;
      grid-gap: 20px 24px;
      grid-template-columns: 1fr 1fr
    }

    @include media(lg) {
      grid-gap: 32px;
    }

    @include media(xxl) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .partners-page__item {
    &:not(:last-child) {
      @include media(sm-max) {
        margin-bottom: 20px;
      }
    }
  }

  .partners-page__card {
    height: 100%;
  }
</style>
